import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, Image, Toast } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../../../components/Card";

import blueBackground from "../../../assets/images/auth/01.png";
import { login } from "../../../services/service";
import { useAuth } from "../../../components/auth/context/context";

const SignIn = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const userData = await login(email, password);
      setUser(userData);
      localStorage.setItem(
        "commissionType",
        userData?.commission?.commissionType
      );
      localStorage.setItem("commissionValue", userData?.commission?.typeValue);
      // Save login info if "Remember Me" is checked
      if (rememberMe) {
        localStorage.setItem("user", JSON.stringify(userData));
      } else {
        sessionStorage.setItem("user", JSON.stringify(userData));
      }

      navigate("/dashboard");
    } catch (error) {
      setToastMessage(error.response?.data?.message || "Login failed");
      setShowToast(true);
    }
  };

  useEffect(() => {
    const savedUser =
      localStorage.getItem("user") || sessionStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const agrirentTextStyle = {
    fontSize: "3.8rem",
    fontWeight: "bold",
    color: "#ffffff",
    textTransform: "uppercase",
    fontFamily: "Georgia, serif",
    textAlign: "center",
    textShadow: "0px 2px 6px rgba(0,0,0,0.3)",
  };

  const overlayStyle = {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to bottom right, rgba(13, 110, 253, 0.4), rgba(0, 0, 100, 0.5))",
    backdropFilter: "blur(3px)",
    zIndex: 1,
  };

  const formCardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "2rem",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
    border: "1px solid #e6e6e6",
  };

  const buttonStyle = {
    backgroundColor: "#0d6efd",
    borderColor: "#0d6efd",
    fontWeight: 600,
    borderRadius: "8px",
    transition: "all 0.3s ease",
  };

  return (
    <section className="login-content">
      {/* Toast notification */}
      <Toast
        show={showToast}
        onClose={() => setShowToast(false)}
        style={{
          position: "absolute",
          top: 20,
          right: 20,
          zIndex: 1000,
        }}
      >
        <Toast.Header>
          <strong className="me-auto">Login Error</strong>
        </Toast.Header>
        <Toast.Body>{toastMessage}</Toast.Body>
      </Toast>

      <Row className="m-0 align-items-center bg-white vh-100">
        {/* Left Side - Login Form */}
        <Col md="6">
          <Row className="justify-content-center">
            <Col md="10">
              <Card
                className="shadow-none d-flex justify-content-center mb-0 bg-transparent"
                style={formCardStyle}
              >
                <Card.Body>
                  <div className="text-center mb-4">
                    <h1
                      className="mb-1"
                      style={{
                        fontSize: "2.2rem",
                        fontWeight: "700",
                        color: "#0d6efd",
                      }}
                    >
                      Shetu
                    </h1>
                    <p className="text-muted mb-0">Login to your admin panel</p>
                  </div>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ borderRadius: "8px" }}
                        required
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        style={{ borderRadius: "8px" }}
                        required
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <Form.Check
                        type="checkbox"
                        label="Remember Me"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <Link to="/auth/reset-password" className="text-primary">
                        Forgot Password?
                      </Link>
                    </div>

                    <Button type="submit" className="w-100" style={buttonStyle}>
                      Sign In
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>

        {/* Right Side - Background with Blur Overlay & Title */}
        <Col
          md="6"
          className="d-md-flex d-none align-items-center justify-content-center p-0 vh-100 position-relative"
        >
          <Image
            src={blueBackground}
            alt="blue background"
            className="w-100 h-100 object-fit-cover position-absolute"
            style={{ zIndex: 0 }}
          />
          <div style={overlayStyle}></div>
          <div style={{ zIndex: 2 }}>
            <h1 style={agrirentTextStyle}>Shetu</h1>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default SignIn;
